export default __webpack_public_path__ + "static/static-banner376-img-89b27726816286276fc2a8d5e954312e.jpg";